
import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenAssignCreditnotePubSub, OpenAssignCreditnotePubSubPayload } from "@utils/pubsubs/PubSub";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";
import { CreditnoteApi, CreditnoteDataType } from "@/api/CreditnoteApi";
import InvoiceAsignementSearchForm from "@components/dynamic/InvoiceAsignementSearchForm";
import { ClientStatusRowData } from "@utils/DocumentStatus";

type AssignCreditnoteOffCanvasProps = {
    onAssignmentDone: () => void
} & DefaultOffCanvasProps

const AssignCreditnoteOffCanvas = (props: AssignCreditnoteOffCanvasProps) => {
    const { btnColor = "primary", className, onAssignmentDone } = props;
    const [creditNote, setCreditnote] = useState<CreditnoteDataType>({} as CreditnoteDataType);
    const [isOpen, setOpen] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        const unsubscribe = OpenAssignCreditnotePubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenAssignCreditnotePubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
        setCreditnote(payload.creditNote)
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const onInvoiceSelect = async (invoice: ClientStatusRowData) => {
        const creditNoteTotal = Number(creditNote.total)
        if (creditNoteTotal > invoice.saldo) {
            showAlert("danger", "El monto de la nota de credito es mayor al saldo de la factura a la cual se desea asignar la nota de credito")
        }
        try {
            setShowLoading(true)
            await CreditnoteApi.update(`${creditNote.id}`, {
                appliedInvoiceId: invoice.id,
            })
            showAlert("success", `La nota de credito ha sido asignado a la factura #${invoice.numero}`)
            onCanvasClosed()
            setTimeout(() => {
                onAssignmentDone()
            });
        } catch (err) {
            if (err instanceof Error) {
                showAlert("danger", err.message)
            }
        } finally {
            setShowLoading(false)
        }

    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Asignar Nota de Credito
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert className="mb-4" color="warning">
                            Por favor seleccione la factura a la cual se le va a asignar esta nota de credito
                        </Alert>
                        <InvoiceAsignementSearchForm
                            onInvoiceSelect={onInvoiceSelect}
                            clientId={`${creditNote.clientId}`}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
            <LoadingScreen isLoading={showLoading} />
        </>
    );
}
export default AssignCreditnoteOffCanvas;
